/* eslint-disable max-len */
/* eslint-disable class-methods-use-this */
import { Component, computed, DestroyRef, inject, input, NgZone, output } from '@angular/core';
import {
  ExternalSystemCurrentAndPreviousStateStatus,
  ExternalSystemInfo,
  ExternalSystemStatusItem,
  ExternalSystemStatusType,
} from '../../models/external-system.status.model';
import moment from 'moment-timezone';

@Component({
  selector: 's2a-banner',
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
  standalone: false,
})
export class BannerComponent {
  expanded = false;
  externalSystemInfo = input<ExternalSystemStatusItem | null>({
    accountId: '',
    previousState: {
      status: ExternalSystemCurrentAndPreviousStateStatus.disconnected,
      timestamp: '',
    },
    systemInfo: ExternalSystemInfo.readykit,
    title: '',
    subTitle: '',
    type: ExternalSystemStatusType.error,
    description: '',
    currentState: {
      status: ExternalSystemCurrentAndPreviousStateStatus.connected,
      timestamp: '',
    },
    metaData: {
      lineId: '',
      lineName: '',
    },
  });
  showDescription = input(true);
  connected = computed(() => this.externalSystemInfo()?.type === ExternalSystemStatusType.success);
  showDetail = output<ExternalSystemStatusItem>();
  openContactSupport = output<ExternalSystemStatusItem>();
  closeBanner = output<ExternalSystemStatusItem>();
  currentTimeStamp = moment().valueOf();
  intervalId: any;
  private destroyRef = inject(DestroyRef);

  constructor(private ngZone: NgZone) {
    this.ngZone.runOutsideAngular(() => {
      setInterval(() => {
        this.currentTimeStamp = moment().valueOf();
      }, 1);
    });
    this.destroyRef.onDestroy(() => {
      clearInterval(this.intervalId);
    });
  }

  /**
   * Method is used to open the banner dialogue details
   */
  openSystemInfoDialogue(item: ExternalSystemStatusItem): void {
    this.showDetail.emit(item);
  }

  /**
   * Method is used to close the banner
   */
  closeExternalSystemStatusBanner(externalStatusItem: ExternalSystemStatusItem): void {
    this.closeBanner.emit(externalStatusItem);
  }

  /**
   * Method is used to open contact support dialogue box
   */
  openContactSuppotDialogue(item: ExternalSystemStatusItem): void {
    this.openContactSupport.emit(item);
  }

  /**
   * Method is used to toggle the panel
   */
  toggleUI(): void {
    this.expanded = !this.expanded;
  }
}
